export default {
  appTitle: 'Web Mobile - Grandvillard',
  imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}
